/* Next10 — Imprensa: autoplay da tira no celular (paridade com o slick do site antigo).
   Só roda em telas <= 749px, quando a tira está visível, fora do editor de temas e
   sem prefers-reduced-motion. Pausa enquanto o dedo/mouse está na tira. */
class N10PressTrack extends HTMLElement {
  connectedCallback() {
    this.speed = parseInt(this.dataset.autoplay || '0', 10);
    if (!this.speed || this.children.length < 2) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.mq = window.matchMedia('(max-width: 749px)');
    this.index = 0;
    this.timer = null;
    this.visible = false;
    this.held = false;

    this.onDown = () => {
      this.held = true;
      this.stop();
    };
    this.onUp = () => {
      this.held = false;
      this.start();
    };
    this.onScroll = () => {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => this.sync(), 120);
    };
    this.onMedia = () => this.start();

    this.addEventListener('pointerdown', this.onDown, { passive: true });
    this.addEventListener('pointerup', this.onUp, { passive: true });
    this.addEventListener('pointercancel', this.onUp, { passive: true });
    if (window.matchMedia('(hover: hover)').matches) {
      this.addEventListener('mouseenter', this.onDown);
      this.addEventListener('mouseleave', this.onUp);
    }
    this.addEventListener('scroll', this.onScroll, { passive: true });
    this.mq.addEventListener('change', this.onMedia);

    this.io = new IntersectionObserver(
      (entries) => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.start();
        else this.stop();
      },
      { threshold: 0.4 }
    );
    this.io.observe(this);
  }

  disconnectedCallback() {
    this.stop();
    if (this.io) this.io.disconnect();
    if (this.mq) this.mq.removeEventListener('change', this.onMedia);
  }

  /* Depois de um arrasto manual, descobre qual item ficou no centro. */
  sync() {
    const center = this.scrollLeft + this.clientWidth / 2;
    let best = 0;
    let dist = Infinity;
    Array.from(this.children).forEach((el, i) => {
      const d = Math.abs(el.offsetLeft + el.offsetWidth / 2 - center);
      if (d < dist) {
        dist = d;
        best = i;
      }
    });
    this.index = best;
  }

  start() {
    this.stop();
    if (!this.visible || this.held || !this.mq.matches) return;
    this.timer = setInterval(() => this.next(), this.speed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  next() {
    const items = this.children;
    this.index = (this.index + 1) % items.length;
    const el = items[this.index];
    this.scrollTo({
      left: el.offsetLeft - (this.clientWidth - el.offsetWidth) / 2,
      behavior: 'smooth'
    });
  }
}

if (!customElements.get('n10-press-track')) {
  customElements.define('n10-press-track', N10PressTrack);
}
